export const gtmSearchResultsProductClickEvent = (
  productTier: string,
  productName: string,
  searchQuery: string,
  sku: string,
) => {
  return {
    event: 'search_click',
    eventCategory: 'Search',
    eventLabel: `Click on ${productName}`,
    productName,
    productTier,
    sku,
    searchQuery,
  };
};

export default gtmSearchResultsProductClickEvent;
